import React from 'react';
import PropTypes from 'prop-types';
import HomeSection from '../HomeSection';
import MediaSubLabel from '../../../molecules/MediaSubLabel';
import MediaUploadButton from '../../../molecules/MediaUploadButton';
import EditorialEmptyState from '../../../molecules/EditorialEmptyState';
import MediaPhotoGallery from '../../MediaPhotoGallery';

export default function HomeGallerySection({
  id = 'gallery',
  eyebrow,
  title,
  side,
  photos = [],
  photosLabel,
  photosMeta,
  emptyPhotosTitle,
  emptyPhotosDescription,
  uploadPhotoLabel = 'Upload photo',
  onPhotoClick,
  onUploadPhoto,
  isEditing = false,
  onDeletePhoto,
  onReorderPhotos,
  deletingPhotoId = null,
  isReorderingPhotos = false,
  deletePhotoLabel = 'Delete photo',
  previousPhotosLabel = 'Scroll photos left',
  nextPhotosLabel = 'Scroll photos right',
  className = '',
}) {
  const photoUploadButton = typeof onUploadPhoto === 'function' ? (
    <MediaUploadButton
      variant="photo"
      label={uploadPhotoLabel}
      onUpload={onUploadPhoto}
    />
  ) : photosMeta;

  return (
    <HomeSection
      id={id}
      eyebrow={eyebrow}
      title={title}
      side={side}
      showSide={isEditing}
      className={`home-gallery ${className}`.trim()}
    >
      <MediaSubLabel title={photosLabel} meta={photoUploadButton} />
      {photos.length > 0 ? (
        <MediaPhotoGallery
          photos={photos}
          isEditing={isEditing}
          onPhotoClick={onPhotoClick}
          onDeletePhoto={onDeletePhoto}
          onReorderPhotos={onReorderPhotos}
          deletingPhotoId={deletingPhotoId}
          isReorderingPhotos={isReorderingPhotos}
          deletePhotoLabel={deletePhotoLabel}
          previousPhotosLabel={previousPhotosLabel}
          nextPhotosLabel={nextPhotosLabel}
        />
      ) : (
        <EditorialEmptyState
          title={emptyPhotosTitle}
          description={emptyPhotosDescription}
        />
      )}
    </HomeSection>
  );
}

HomeGallerySection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  side: PropTypes.node,
  photos: PropTypes.array,
  photosLabel: PropTypes.node,
  photosMeta: PropTypes.node,
  emptyPhotosTitle: PropTypes.node,
  emptyPhotosDescription: PropTypes.node,
  uploadPhotoLabel: PropTypes.node,
  onPhotoClick: PropTypes.func,
  onUploadPhoto: PropTypes.func,
  isEditing: PropTypes.bool,
  onDeletePhoto: PropTypes.func,
  onReorderPhotos: PropTypes.func,
  deletingPhotoId: PropTypes.string,
  isReorderingPhotos: PropTypes.bool,
  deletePhotoLabel: PropTypes.string,
  previousPhotosLabel: PropTypes.string,
  nextPhotosLabel: PropTypes.string,
  className: PropTypes.string,
};
